<template>
  <div class="jac-region-container">
    <v-card class="custom-card mb-6">
      <div class="header-section px-8 py-6 mx-4 mt-4 mb-2">
        <v-row
          align="center"
          justify="space-between"
          class="ma-0 header-content"
        >
          <div class="mb-4 mb-md-0">
            <h6 class="subtitle-text text-uppercase mb-1">
              {{ PageDescription }}
            </h6>
            <h2 class="title-text text-h4 font-weight-bold mb-0">
              {{ PageTitle }}
            </h2>
          </div>
          <div class="d-flex flex-wrap gap-4 align-center">
            <v-btn
              :disabled="!valid1"
              @click.prevent="refreshPageData"
              class="btn-refresh-icon"
              elevation="0"
              icon
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
              :disabled="!valid1"
              @click.prevent="addRecordPrompt = true"
              class="btn-create-solid px-6 py-5"
              elevation="2"
            >
              <v-icon left size="20">mdi-plus</v-icon> Create Region
            </v-btn>
          </div>
        </v-row>
      </div>

      <v-card-text class="px-6 pt-4 pb-6">
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
            style="color: #3a67b1"
          ></b-spinner>
        </div>

        <v-container class="py-0 px-0">
          <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
            <v-row
              wrap
              align="end"
              class="search-form-row px-3 py-4 mx-0 mb-4 rounded-lg"
            >
              <v-col cols="12" md="4" class="py-2">
                <label class="form-label">
                  <span style="color: #edbe38; font-weight: bold">*</span> Zone
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  dense
                  clearable
                  required
                  outlined
                  hide-details="auto"
                  background-color="#FFFFFF"
                  color="#3A67B1"
                  class="custom-input"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3" class="py-2">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="searchForm"
                  :loading="SearchFlag"
                  class="btn-search px-8 py-5 elevation-2"
                  block
                >
                  <v-icon left>mdi-magnify</v-icon> Search
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <v-container
          class="py-0 px-0 data-table-container"
          v-if="tableData1.length > 0"
        >
          <v-row wrap class="mb-4 align-center mx-0">
            <v-col cols="12" md="6" class="py-0">
              <h4 class="records-found-text">
                <v-icon color="#3A67B1" class="mr-2"
                  >mdi-format-list-bulleted</v-icon
                >
                {{ tableData1.length }} Records found
              </h4>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records..."
                single-line
                hide-details
                outlined
                dense
                color="#3A67B1"
                background-color="#FFFFFF"
                class="custom-search-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row wrap class="mx-0">
            <v-col cols="12" md="12" class="py-0">
              <v-data-table
                class="elevation-2 custom-table"
                v-model="selected"
                :search="search"
                :item-key="tableOptions1.ItemKey"
                :single-select="tableOptions1.SingleSelectFlag"
                :headers="tableColumns1"
                :items="tableData1"
                :items-per-page="tableOptions1.ItemsPerPage"
                :footer-props="tableOptions1.FooterProps"
              >
                <template v-slot:item.ActiveStatus="{ item }">
                  <v-chip
                    :color="item.StatusColor"
                    class="white--text font-weight-bold"
                    small
                  >
                    {{ item.ActiveStatus }}
                  </v-chip>
                </template>
                <template v-slot:item.Actions="{ item }">
                  <v-btn
                    icon
                    class="action-btn preview-btn"
                    @click="previewRecord(item)"
                    title="Preview"
                  >
                    <v-icon size="18px">mdi-eye-outline</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="action-btn edit-btn"
                    @click="editRecord(item)"
                    title="Edit"
                  >
                    <v-icon size="18px">mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addRecordPrompt" max-width="1000px">
      <jac-region-create
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt($event)"
        :recordIndex="recordToEdit"
        v-if="addRecordPrompt"
      ></jac-region-create>
    </v-dialog>
    <v-dialog v-model="editRecordPrompt" max-width="1000px">
      <jac-region-edit
        :editRecordPrompt="editRecordPrompt"
        @hideEditRecordPrompt="hideEditRecordPrompt($event)"
        :recordData="recordData"
        v-if="editRecordPrompt"
      ></jac-region-edit>
    </v-dialog>
    <v-dialog v-model="previewRecordPrompt" max-width="1000px">
      <jac-region-preview
        :previewRecordPrompt="previewRecordPrompt"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt($event)"
        :recordData="recordData"
        v-if="previewRecordPrompt"
      ></jac-region-preview>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import JacRegionCreate from "@/view/pages/erp/jac-region/JacRegionCreate.vue";
import JacRegionEdit from "@/view/pages/erp/jac-region/JacRegionEdit.vue";
import JacRegionPreview from "@/view/pages/erp/jac-region/JacRegionPreview.vue";

export default {
  components: {
    JacRegionCreate,
    JacRegionEdit,
    JacRegionPreview,
  },
  mixins: [common],
  data() {
    return {
      PageTitle: "JAC Region List",
      PageDescription: "search the regions by the filter",
      LoadingFlag: false,
      SearchFlag: false,

      valid1: true,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      tableData1: [],
      tableColumns1: [],
      tableOptions1: {},
      selected: [],
      search: "",

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      recordData: {},
      recordToEdit: 0,
      PageInfo: {},
    };
  },
  mounted() {
    this.refreshPageData();
    this.getZoneCodeOptions();
  },
  watch: {
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
    },
    PageInfo: function () {
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      var n1 = Object.keys(tr).length;
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
      }
    },
  },
  methods: {
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log({ flag });
      if (flag) {
        this.refreshPageData();
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    editRecord(item) {
      console.log("editRecord called");
      this.recordData = item;
      this.editRecordPrompt = true;
    },
    previewRecord(item) {
      console.log("previewRecord called");
      this.recordData = item;
      this.previewRecordPrompt = true;
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.ZoneCode = "";
      this.tableData1 = [];
      this.selected = [];
      this.search = "";
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_region",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getZoneCodeOptions() {
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/zone/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      var validate1 = this.$refs.form1.validate();
      if (validate1) {
        this.getTableRecords();
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    getTableRecords() {
      this.LoadingFlag = true;
      this.SearchFlag = true;
      this.tableData1 = [];

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jac-region/lists";

      var YearCode = this.YearCode;
      var ZoneCode = this.ZoneCode;

      var upload = {
        UserInterface: 1,
        Year: YearCode,
        Zone: ZoneCode,
      };

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.LoadingFlag = false;
          thisIns.SearchFlag = false;

          var output = response.data.output;
          var flag = response.data.flag;
          var records = response.data.records;

          if (flag == 1) {
            thisIns.tableColumns1 = records.TableHeader;
            thisIns.tableOptions1 = records.TableOptions;
            thisIns.tableData1 = records.TableData;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.LoadingFlag = false;
          thisIns.SearchFlag = false;
          console.log("error=" + error);
          thisIns.toast("error", error);
        });
    },
  },
};
</script>

<style scoped>
.jac-region-container {
  font-family: "Inter", "Roboto", sans-serif;
  background-color: #f8f9fa;
  min-height: 100%;
}

.custom-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(10, 15, 41, 0.05),
    0 2px 4px -1px rgba(10, 15, 41, 0.03) !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(65, 64, 66, 0.08);
}

.header-section {
  background: linear-gradient(135deg, #3a67b1 0%, #2c508a 100%);
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}
.header-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 15% 50%,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0.06) 120px,
      transparent 120px
    ),
    radial-gradient(
      circle at 85% 30%,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.04) 180px,
      transparent 180px
    ),
    radial-gradient(
      circle at 50% 120%,
      rgba(255, 255, 255, 0.03) 0%,
      rgba(255, 255, 255, 0.03) 250px,
      transparent 250px
    );
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.title-text {
  color: #ffffff !important;
  letter-spacing: 0.5px;
}

.subtitle-text {
  color: #edbe38 !important;
  letter-spacing: 1.5px;
  font-weight: 700;
  font-size: 0.75rem;
}

.btn-refresh-icon {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease;
}
.btn-refresh-icon:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: rotate(90deg);
}

.btn-create-solid {
  background-color: #ffffff !important;
  color: #3a67b1 !important;
  border-radius: 8px;
  text-transform: none !important;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}
.btn-create-solid:hover {
  background-color: #f0f4f8 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-search {
  background-color: #3a67b1 !important;
  color: #ffffff !important;
  border-radius: 8px;
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(58, 103, 177, 0.2) !important;
}
.btn-search:hover {
  background-color: #2c508a !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(58, 103, 177, 0.25) !important;
}

.search-form-row {
  background-color: rgba(0, 151, 215, 0.03);
  border: 1px solid rgba(0, 151, 215, 0.1);
}

.form-label {
  color: #0a0f29;
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
  font-size: 0.95rem;
}

.custom-input .v-input__control .v-input__slot {
  border-radius: 6px;
}

.data-table-container {
  margin-top: 24px;
  border-top: 2px dashed rgba(65, 64, 66, 0.1);
  padding-top: 24px !important;
}

.records-found-text {
  font-weight: 600;
  color: #3a67b1;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}

.custom-search-input {
  border-radius: 8px;
}
.custom-search-input ::v-deep .v-input__control .v-input__slot {
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(10, 15, 41, 0.05) !important;
}

.custom-table {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.custom-table ::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  border: 1px solid rgba(65, 64, 66, 0.08);
  background-color: #ffffff;
  box-shadow: 0 4px 20px -4px rgba(10, 15, 41, 0.05) !important;
  overflow: hidden;
}
.custom-table ::v-deep th {
  background-color: #3a67b1 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: none !important;
  padding: 14px 20px !important;
}
.custom-table ::v-deep th .v-icon {
  color: #ffffff !important;
}
.custom-table ::v-deep td {
  color: #0a0f29 !important;
  font-weight: 500;
  font-size: 0.9rem !important;
  padding: 16px 20px !important;
  border-bottom: 1px solid rgba(65, 64, 66, 0.04) !important;
}
.custom-table ::v-deep tbody tr {
  transition: all 0.2s ease;
  background-color: #ffffff !important;
}
.custom-table ::v-deep tbody tr:hover {
  background-color: rgba(58, 103, 177, 0.03) !important;
}
.custom-table ::v-deep tbody tr:hover td:first-child {
  box-shadow: inset 4px 0 0 #3a67b1 !important;
}
.custom-table ::v-deep .v-chip {
  border-radius: 6px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 0 10px;
  height: 24px;
  font-size: 0.75rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-btn {
  border-radius: 8px !important;
  width: 32px !important;
  height: 32px !important;
  transition: all 0.2s ease;
  margin: 0 4px;
}
.preview-btn {
  background-color: rgba(0, 151, 215, 0.08) !important;
  color: #0097d7 !important;
  border: 1px solid rgba(0, 151, 215, 0.15) !important;
}
.preview-btn:hover {
  background-color: #0097d7 !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 151, 215, 0.2) !important;
}
.edit-btn {
  background-color: rgba(237, 190, 56, 0.1) !important;
  color: #d4a017 !important; /* Darker gold for contrast */
  border: 1px solid rgba(237, 190, 56, 0.2) !important;
}
.edit-btn:hover {
  background-color: #edbe38 !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(237, 190, 56, 0.25) !important;
}

.gap-4 {
  gap: 16px;
}
</style>
